import React from 'react';
import { Block } from "@randajan/jet-react/dom/block";

import "./ProfileHeader.scss";
import { Caption } from '@randajan/jet-react/dom/caption';
import { LogoutButton } from '../../Oauth/LogoutButton/LogoutButton';
import { Locale } from '../../../assets/Locale';

export const ProfileHeader = (props) => {
    const { profile, showMe } = props;
    const say = Locale.use();

    const caption = showMe ? say("navProfile") : say("profileHeaderMember");

    return (
        <Block level={0} className="ProfileHeader wall -dark -border">
            <div className="header">
                <Caption>{caption}</Caption>
                {!showMe ? null : <LogoutButton/>}
            </div>
        </Block>
    )
}

